import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNotify, useRefresh } from 'react-admin';
import { BillingAccountDeleteModal } from './BillingAccountDeleteModal';

interface Props {
	record: any;
}

// BillingAccountDeleteListButton : la suppression depuis la LISTE, avec la même
// modale que la fiche — celle qui exige de retaper le nom du compte et qui
// détaille ce que la cascade emporte.
//
// ⚠️ Elle remplace le ConfirmDeleteButton générique, dont le « êtes-vous sûr ? »
// se cliquait par réflexe. La suppression d'un compte détruit ses projets, son
// entrepôt managé chez Google et son customer Stripe : deux chemins vers la même
// action irréversible ne peuvent pas demander deux niveaux de confirmation
// différents — c'est toujours le plus faible qui sert.
export const BillingAccountDeleteListButton: React.FC<Props> = ({ record }) => {
	const [open, setOpen] = useState(false);
	const refresh = useRefresh();
	const notify = useNotify();

	if (!record?.id) return null;

	// ⚠️ stopPropagation : la ligne du tableau est cliquable (rowClick vers la
	// fiche). Sans ça, ouvrir la modale navigue en même temps et elle se ferme
	// aussitôt.
	const stop = (e: React.MouseEvent) => {
		e.stopPropagation();
		e.preventDefault();
	};

	return (
		<>
			<Tooltip title="Supprimer ce compte">
				<IconButton
					size="small"
					color="error"
					onClick={(e) => {
						stop(e);
						setOpen(true);
					}}
				>
					<DeleteIcon fontSize="small" />
				</IconButton>
			</Tooltip>
			{open && (
				<div onClick={stop} role="presentation">
					<BillingAccountDeleteModal
						billingAccount={{ id: String(record.id), name: record.name || '' }}
						open={open}
						onClose={() => setOpen(false)}
						onDeleted={() => {
							setOpen(false);
							notify('Compte supprimé', { type: 'success' });
							refresh();
						}}
					/>
				</div>
			)}
		</>
	);
};
